<template>


    <Dialog v-model:visible="visibleBanDialog" modal :header="$t('dialogs.ban_dialogue.title') + getNickname()"
        :style="{ width: '25rem' }">
        <span class="p-text-secondary block mb-5"> 
            {{ $t('dialogs.ban_dialogue.title', { channel: getChannelName() }) }}
            </span>
        <div class=" flex flex-column justify-content-start mb-5">
            <label class="font-semibold w-6rem mb-2">{{  $t('dialogs.ban_dialogue.action') }}</label>
            <div class="flex flex-column gap-3">
                <div v-for="op of checkBoxOptions" :key="op.key" class="flex align-items-center">
                    <Checkbox v-model="selectedOption" :inputId="op.key" name="category" :value="op.key" />
                    <label :for="op.key" class="ml-2">{{ op.name }}</label>
                </div>
            </div>
        </div>
        <div class="flex flex-column align-items-start gap-3 mb-5">
            <label class="font-semibold w-6rem">{{  $t('dialogs.ban_dialogue.reason') }}</label>
            <Textarea v-model="banReason" rows="5" cols="30" />
        </div>
        <div class="flex justify-content-end gap-2">
            <Button type="button" label="Kick & Ban User" severity="danger" @click="banAction"></Button>
            <Button type="button" label="Cancel" severity="secondary" @click="visibleBanDialog = false"></Button>
        </div>
    </Dialog>

</template>

<script>
export default {
    name: "BanDialog",
    props: ['userData', 'channel'],
    data() {
        return {
            visibleBanDialog: false,
            banReason: '',
            checkBoxOptions: [
                { name: this.$t('dialogs.ban_dialogue.ban_n'), key: "ban_BN" },
                { name: this.$t('dialogs.ban_dialogue.ban_i'), key: "ban_BI" },
                { name: this.$t('dialogs.ban_dialogue.ban_f'), key: "ban_BF" },
                { name: this.$t('dialogs.ban_dialogue.ban_k'), key: "ban_K" },
            ],
            selectedOption: ["ban_K"],
        }
    },
    computed: {
        getChannelName() {
            if (this.channel) {
                return this.channel.name
            } else {
                return "Server"
            }
        }
    },
    methods: {
        getNickname() {
            if (this.userData) {
                return this.userData.nickname
            }
        },
        showDialog() {
            this.selectedOption = ["ban_K"]
            this.banReason = ""
            this.visibleBanDialog = true
        },
        banAction() {
            this.visibleBanDialog = false
            if (this.selectedOption.length > 0) {
                this.selectedOption.forEach(element => {
                    if (element === "ban_BN") {
                        this.$socket.emit('ban', { user_id: this.userData.user_id, type: "nickname", channel_id: this.channel ? this.channel.id : 0, reason: this.banReason });
                    } else if (element === "ban_BI") {
                        this.$socket.emit('ban', { user_id: this.userData.user_id, type: "ip", channel_id: this.channel ? this.channel.id : 0, reason: this.banReason });
                    } else if (element === "ban_BF") {
                        this.$socket.emit('ban', { user_id: this.userData.user_id, type: "fingerprint", channel_id: this.channel ? this.channel.id : 0, reason: this.banReason });
                    }

                    if (element === "ban_K" && this.channel) {
                        this.$socket.emit('kick', { user_id: this.userData.user_id, channel_id: this.channel ? this.channel.id : 0, reason: this.banReason });
                    }
                });

            }
        },
    }

}
</script>